import { useCurrentLanguage } from "../store/hooks"
import { Language } from "@prisma/client"

export const useIsHeLanguage = () => {
    const language = useCurrentLanguage()
    const isHeLanguage = language === Language.he

    return { isHeLanguage }
}
